import React from 'react'
import styled from 'styled-components'
import { Button } from 'components/Button'

const StyledSwitch = styled.div`
  display: flex;
  flex: 0 0 100%;
  width: 100%;
`
const ButtonWrapper = styled.div`
  flex: 1 1 auto;
  margin-right: 4px;
`
export const Switch = ({
  entries,
  current,
  change,
  disabled
}: {
  entries: { label: string | JSX.Element; value: string | number }[]
  current: string | number
  change: (e: string | number) => void
  disabled: boolean
}) => {
  return (
    <StyledSwitch className='Switch'>
      {entries.map(({ label, value }, i) => {
        return (
          <ButtonWrapper key={'switch' + i}>
            <Button
              size='normal'
              type={current === value ? 'primary' : 'secondary'}
              onClick={() => {
                if (!disabled) change(value)
              }}
              fullWidth
              disabled={current !== value && disabled}
            >
              {label}
            </Button>
          </ButtonWrapper>
        )
      })}
    </StyledSwitch>
  )
}
